<!-- components/WrAboutCards.vue -->
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

type Card = {
    id: string
    heading: string
    paragraph: string
    appendClass?: string
    appendBorder?: string
    bgImage?: string
    paragraphColor?: string
    appendImgClass?: string
}

defineProps<{
    cards: Card[]
}>()
</script>

<template>

    <div v-for="card in cards" :key="card.id" :class="twMerge(
        'p-px min-w-[243px] max-w-[243px] rounded-xl text-white relative',
        card?.appendBorder
    )">
        <div :class="twMerge(
            'w-full h-full rounded-xl px-6 py-7 bg-center bg-no-repeat',
            card?.appendClass
        )">
            <div class="flex flex-col items-start justify-start h-full relative">
                <p class="text-[48px] font-semibold text-[#e4ecff]">
                    {{ card.id }}.
                </p>
                <p class="text-xl font-semibold mt-2" v-html="card.heading" />
                <p :class="twMerge('text-base mt-3 text-white', card.paragraphColor)" v-html="card.paragraph" />
            </div>
        </div>
    </div>
</template>
